/* eslint-disable @typescript-eslint/no-explicit-any */
/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */
import {
	QueryClient,
	UseMutationOptions,
} from '@tanstack/react-query';

/* -------------------------------------------------------------------------- */
/*                                    Lib                                     */
/* -------------------------------------------------------------------------- */
export const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			refetchOnWindowFocus: false,
			retry: false,
			staleTime: 1000 * 60,
		},
	},
});

export type QueryConfig<
	T extends (...args: any[]) => any,
> = Omit<ReturnType<T>, 'queryKey' | 'queryFn'>;

export type ApiFnReturnType<
	FnType extends (...args: any) => Promise<any>,
> = Awaited<ReturnType<FnType>>;

export type TMutationConfig<
	MutationFnType extends (...args: any) => Promise<any>,
> = UseMutationOptions<
	ApiFnReturnType<MutationFnType>,
	Error,
	Parameters<MutationFnType>[0]
>;
